import styled from '@emotion/styled';
import { PromoCtaButton } from '../../../shared/ui/promo-cta';

export const Button = styled(PromoCtaButton)`
  background: var(--color-cta-vote);
  color: var(--color-text-on-dark);

  &:hover:not(:disabled) {
    background: #2a2a2a;
  }
`;
